import { takeEvery, takeLatest } from 'redux-saga/effects';
import { placementModsAction } from './slice';
import {
  requestEndDateModDetails,
  requestPlacementModsList,
  requestStartDateModDetails,
  requestStartDateReasonCodes,
  requestMinReqHoursModDetails,
  requestPayRateModDetails,
  requestTravelAllowanceModDetails,
  requestShiftModDetails,
  requestAdditionalPremiumPayRate,
  requestLodgingModDetails,
  requestExceptionsPayRateGww,
  requestInsuranceModDetails,
  requestEffectiveDateTypes,
  requestInsuranceTypes,
  requestPtoModDetails,
  requestPricingReason,
  requestBillRateModDetails,
  requestRateShiftList,
  requestCancellationHoursFrequencyList,
  requestOgpInternationalLoanModDetails,
  requestBonusModDetails,
  requestReimbursement,
  requestReimbursementCategoryAndFrequency,
  requestPayeeList,
  requestTimeOff,
  requestEmiLmoModDetails,
  requestHousingModDetails,
  requestFurniture,
  requestPreferencesModDetails,
  requestInitiators,
  requestPayrollShiftDifferential,
  requestShiftDifferentialTypes,
  requestShiftDifferentialDescriptionTypes,
  requestShiftDifferentialTemplateTypes,
  requestRefreshPlacementModList,
  requestBillingShiftDifferential,
  requestShiftDifferentialTemplateItems,
  requestModifications,
  requestBookingApprovedCheckboxSpecs,
  requestCheckRefreshContractPayroll,
} from './request.saga';
import {
  addLodgingModDetails,
  addMinReqHoursModDetails,
  addPayRateModDetails,
  updatePayRateModDetails,
  addStartDateModDetails,
  deleteMods,
  updateTravelAllowanceModDetails,
  updateLodgingModDetails,
  updateMinReqHoursModDetails,
  updateStartDateModDetails,
  updateEndDateModDetails,
  voidMods,
  addEndDateModDetails,
  updateShiftModDetails,
  addTimeOffModDetails,
  updateTimeOffModDetails,
  addArrivingTravelModDetails,
  updateEmiLmoModDetails,
  addShiftModDetails,
  updateInsuranceModDetails,
  refreshModDetails,
  updateReimbursementModDetails,
  addReimbursementModDetails,
  addFurnitureModDetails,
  updateFurnitureModDetails,
  addInsuranceModDetails,
  updateBillRateModDetails,
  addBillRateModDetails,
  updatePayrollShiftDifferentialModDetails,
  addPayrollShiftDifferentialModDetails,
  updateLinkModTask,
  addEmiLmoModDetails,
  updateBonusModDetails,
  updatePreferenceModDetails,
  addPreferenceModDetails,
  updatePTOModDetails,
  updateOGPModDetails,
  addBonusModDetails,
  updateHousingModDetails,
  addHousingModDetails,
  updateBillingShiftDifferentialModDetails,
  addBillingShiftDifferentialModDetails,
  addPTOModDetails,
  addOGPModDetails,
  saveRefreshContractPayroll,
} from './update.saga';
import {
  createPlacementModDetails,
  deletePlacementMod,
  batchDeletePlacementMod,
  batchUpdatePlacementMod,
  editPlacementModDetails,
  setEditPreferenceRows,
  voidPlacementMod,
} from './business-saga';

export function* placementModsSaga() {
  yield takeEvery(placementModsAction.getModificationAction.type, requestModifications);
  yield takeLatest(placementModsAction.getPlacementModsList, requestPlacementModsList);
  yield takeLatest(placementModsAction.getRefreshPlacementModsList, requestRefreshPlacementModList);
  yield takeLatest(placementModsAction.getStartDateModDetails, requestStartDateModDetails);
  yield takeLatest(placementModsAction.getStartDateReasonCodes, requestStartDateReasonCodes);
  yield takeLatest(placementModsAction.getMinReqHoursModDetails, requestMinReqHoursModDetails);
  yield takeLatest(placementModsAction.getStartDateModDetails, requestStartDateReasonCodes);
  yield takeLatest(placementModsAction.getEndDateModDetails, requestEndDateModDetails);
  yield takeLatest(placementModsAction.getPayRateModDetails, requestPayRateModDetails);
  yield takeLatest(placementModsAction.refreshModDetails, refreshModDetails);
  yield takeLatest(placementModsAction.getTravelAllowanceModDetailAction, requestTravelAllowanceModDetails);
  yield takeLatest(placementModsAction.getShiftModDetailAction, requestShiftModDetails);
  yield takeLatest(placementModsAction.getAdditionalPremiumPayRate, requestAdditionalPremiumPayRate);
  yield takeLatest(placementModsAction.getLodgingModDetails, requestLodgingModDetails);
  yield takeLatest(placementModsAction.getExceptionsPayRateGww, requestExceptionsPayRateGww);
  yield takeLatest(placementModsAction.getInsuranceModDetails, requestInsuranceModDetails);
  yield takeLatest(placementModsAction.getInsuranceTypes, requestInsuranceTypes);
  yield takeLatest(placementModsAction.getEffectiveDateTypes, requestEffectiveDateTypes);
  yield takeLatest(placementModsAction.getBillRateModDetails, requestBillRateModDetails);
  yield takeLatest(placementModsAction.getPricingReason, requestPricingReason);
  yield takeLatest(placementModsAction.getPtoModDetailAction, requestPtoModDetails);
  yield takeLatest(placementModsAction.getRateShiftList, requestRateShiftList);
  yield takeLatest(placementModsAction.getCancellationHoursFrequencyList, requestCancellationHoursFrequencyList);
  yield takeLatest(placementModsAction.getOgpInternationalLoanModDetailAction, requestOgpInternationalLoanModDetails);
  yield takeLatest(placementModsAction.getBonusModDetailAction, requestBonusModDetails);
  yield takeLatest(placementModsAction.updateBonusModDetailsAction, updateBonusModDetails);
  yield takeLatest(placementModsAction.getReimbursement, requestReimbursement);
  yield takeLatest(placementModsAction.getReimbursementCategoryAndFrequency, requestReimbursementCategoryAndFrequency);
  yield takeLatest(placementModsAction.getPayeeList, requestPayeeList);
  yield takeLatest(placementModsAction.getTimeOffModDetails, requestTimeOff);
  yield takeLatest(placementModsAction.getFurnitureModDetails, requestFurniture);
  yield takeLatest(placementModsAction.addFurnitureModDetails, addFurnitureModDetails);
  yield takeLatest(placementModsAction.updateFurnitureModDetails, updateFurnitureModDetails);
  yield takeLatest(placementModsAction.addMinReqHours, addMinReqHoursModDetails);
  yield takeLatest(placementModsAction.addPayRate, addPayRateModDetails);
  yield takeLatest(placementModsAction.updatePayRate, updatePayRateModDetails);
  yield takeLatest(placementModsAction.updateMinReqHours, updateMinReqHoursModDetails);
  yield takeLatest(placementModsAction.getEmiLmoModDetailAction, requestEmiLmoModDetails);
  yield takeLatest(placementModsAction.getHousingModDetailAction, requestHousingModDetails);
  yield takeLatest(placementModsAction.addLodgingModDetails, addLodgingModDetails);
  yield takeLatest(placementModsAction.updateLodgingModDetails, updateLodgingModDetails);
  yield takeLatest(placementModsAction.updateStartDateModDetails, updateStartDateModDetails);
  yield takeLatest(placementModsAction.addStartDateModDetails, addStartDateModDetails);
  yield takeLatest(placementModsAction.updateEndDateModDetails, updateEndDateModDetails);
  yield takeLatest(placementModsAction.addEndDateModDetails, addEndDateModDetails);
  yield takeLatest(placementModsAction.getPreferencesModDetailAction, requestPreferencesModDetails);
  yield takeLatest(placementModsAction.voidModAction, voidMods);
  yield takeLatest(placementModsAction.deleteModAction, deleteMods);
  yield takeLatest(placementModsAction.updateTravelAllowanceModDetailsAction, updateTravelAllowanceModDetails);
  yield takeLatest(placementModsAction.getInitiators, requestInitiators);
  yield takeLatest(placementModsAction.updateShiftModDetails, updateShiftModDetails);
  yield takeLatest(placementModsAction.addTimeOffModDetails, addTimeOffModDetails);
  yield takeLatest(placementModsAction.updateTimeOffModDetails, updateTimeOffModDetails);
  yield takeLatest(placementModsAction.addTravelAllowanceModDetailsAction, addArrivingTravelModDetails);
  yield takeLatest(placementModsAction.addShiftModDetails, addShiftModDetails);
  yield takeLatest(placementModsAction.updateEmiLmoModDetailsAction, updateEmiLmoModDetails);
  yield takeLatest(placementModsAction.addEmiLmoModDetailsAction, addEmiLmoModDetails);
  yield takeLatest(placementModsAction.updateInsuranceModDetails, updateInsuranceModDetails);
  yield takeLatest(placementModsAction.addInsuranceModDetails, addInsuranceModDetails);
  yield takeLatest(placementModsAction.updateReimbursementModDetails, updateReimbursementModDetails);
  yield takeLatest(placementModsAction.addReimbursementModDetails, addReimbursementModDetails);

  yield takeLatest(placementModsAction.updateBillRateModDetails, updateBillRateModDetails);
  yield takeLatest(placementModsAction.addBillRateModDetails, addBillRateModDetails);
  yield takeLatest(placementModsAction.getPayrollShiftDifferential, requestPayrollShiftDifferential);
  yield takeLatest(
    placementModsAction.updatePayrollShiftDifferentialModDetails,
    updatePayrollShiftDifferentialModDetails,
  );
  yield takeLatest(placementModsAction.addPayrollShiftDifferentialModDetails, addPayrollShiftDifferentialModDetails);
  yield takeLatest(placementModsAction.getShiftDifferentialTypes, requestShiftDifferentialTypes);
  yield takeLatest(placementModsAction.getShiftDifferentialDescriptionTypes, requestShiftDifferentialDescriptionTypes);
  yield takeLatest(placementModsAction.getShiftDifferentialTemplateTypes, requestShiftDifferentialTemplateTypes);
  yield takeLatest(placementModsAction.updateLinkModTask, updateLinkModTask);
  yield takeLatest(placementModsAction.getBillingShiftDifferential, requestBillingShiftDifferential);
  yield takeLatest(
    placementModsAction.updateBillingShiftDifferentialModDetails,
    updateBillingShiftDifferentialModDetails,
  );
  yield takeLatest(placementModsAction.addBillingShiftDifferentialModDetails, addBillingShiftDifferentialModDetails);
  yield takeLatest(placementModsAction.updatePreferenceModDetails, updatePreferenceModDetails);
  yield takeLatest(placementModsAction.addPreferenceModDetails, addPreferenceModDetails);
  yield takeLatest(placementModsAction.updatePTOModDetails, updatePTOModDetails);
  yield takeLatest(placementModsAction.addPTOModDetails, addPTOModDetails);
  yield takeLatest(placementModsAction.addBonusModDetailsAction, addBonusModDetails);
  yield takeLatest(placementModsAction.updateHousingModDetailsAction, updateHousingModDetails);
  yield takeLatest(placementModsAction.addHousingModDetailsAction, addHousingModDetails);
  yield takeLatest(placementModsAction.updateOGPModDetails, updateOGPModDetails);
  yield takeLatest(placementModsAction.addOGPModDetails, addOGPModDetails);
  yield takeLatest(placementModsAction.getBookingApprovedCheckboxSpecs.type, requestBookingApprovedCheckboxSpecs);
  yield takeLatest(placementModsAction.getShiftDifferentialTemplateItems, requestShiftDifferentialTemplateItems);
  yield takeLatest(placementModsAction.checkRefreshContractPayroll, requestCheckRefreshContractPayroll);
  yield takeLatest(placementModsAction.saveRefreshContractPayroll, saveRefreshContractPayroll);

  /** BUSINESS ACTIONS - Start */
  yield takeLatest(placementModsAction.business_setEditPreferenceRows, setEditPreferenceRows);
  yield takeLatest(placementModsAction.business_createPlacementMod, createPlacementModDetails);
  yield takeLatest(placementModsAction.business_updatePlacementMod, editPlacementModDetails);
  yield takeLatest(placementModsAction.business_deletePlacementMod, deletePlacementMod);
  yield takeLatest(placementModsAction.business_batchDeletePlacementMod, batchDeletePlacementMod);
  yield takeLatest(placementModsAction.business_batchUpdatePlacementMod, batchUpdatePlacementMod);
  yield takeLatest(placementModsAction.business_voidPlacementMod, voidPlacementMod);
  /** BUSINESS ACTIONS - End */
}
